// Storage utility for saving scan history
const STORAGE_KEY = 'qr_scan_history';

export const saveScanToHistory = (scanData) => {
  try {
    const history = getScanHistory();
    const newEntry = {
      id: Date.now(),
      data: scanData,
      timestamp: new Date().toISOString()
    };
    
    history.unshift(newEntry);
    
    // Keep only the last 50 scans
    if (history.length > 50) {
      history.splice(50);
    }
    
    localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
    return newEntry;
  } catch (error) {
    console.error('Error saving scan to history:', error);
    return null;
  }
};

export const getScanHistory = () => {
  try {
    const history = localStorage.getItem(STORAGE_KEY);
    return history ? JSON.parse(history) : [];
  } catch (error) {
    console.error('Error retrieving scan history:', error);
    return [];
  }
};

export const clearScanHistory = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    return true;
  } catch (error) {
    console.error('Error clearing scan history:', error);
    return false;
  }
};